const GIFT_LIST_STATUS_MAP = {
  PUBLIC: 'PUBLISHED',
  HIDDEN: 'DRAFT',
  EXPIRED: 'EXPIRED',
};

export default function buildGiftListPayload(params = {}) {
  const payload = {
    page: Number(params.page) || 1,
    limit: Number(params.limit) || 10,
  };

  const q = (params.q || '').trim();
  if (q) {
    payload.q = q;
  }

  const { giftType, statusType } = params;

  if (giftType === 'VOUCHER') {
    payload.category = 'VOUCHER';
  } else if (giftType === 'EXCLUSIVE') {
    payload.category = 'EXCLUSIVE';
  } else if (giftType === 'LIMITED') {
    payload.category = 'EXCLUSIVE';
    payload.isFlashSale = true;
  }

  if (statusType && GIFT_LIST_STATUS_MAP[statusType]) {
    payload.status = GIFT_LIST_STATUS_MAP[statusType];
  }

  return payload;
}
